const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M11.5 6.25a.75.75 0 0 1 .75.75v5.07H16a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75V7a.75.75 0 0 1 .75-.75"/><path fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" clip-rule="evenodd"/></svg>';
export {
  e as w
};
